// import axios from "axios";

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL || "https://pineconnector.tradestreet.in/backend",
//   timeout: 10000,
// });

// // ── Dashboard ──────────────────────────────────────────────────────────────
// export const fetchStats = () => api.get("/api/dashboard/stats").then(r => r.data);

// // ── Signals ────────────────────────────────────────────────────────────────
// export const fetchSignals = (skip = 0, limit = 50, status = "") =>
//   api.get("/api/signals/list", { params: { skip, limit, status: status || undefined } }).then(r => r.data);

// // ── Trades ─────────────────────────────────────────────────────────────────
// export const fetchTrades = (skip = 0, limit = 50) =>
//   api.get("/api/trades/list", { params: { skip, limit } }).then(r => r.data);

// // ── Accounts ───────────────────────────────────────────────────────────────
// export const fetchAccounts = () => api.get("/api/accounts/list").then(r => r.data);

// export const createAccount = (data) => api.post("/api/accounts/create", data).then(r => r.data);

// export const updateAccount = (accountId, data) =>
//   api.patch(`/api/accounts/update/${accountId}`, data).then(r => r.data);

// export const deleteAccount = (accountId) =>
//   api.delete(`/api/accounts/delete/${accountId}`).then(r => r.data);

// // ── Webhook test ───────────────────────────────────────────────────────────
// export const sendTestSignal = (payload) =>
//   api.post("/api/signals/webhook", payload).then(r => r.data);

// export default api;


import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://pineconnector.tradestreet.in/backend",
  timeout: 10000,
});

// ── Auth token inject karo har request mein ───────────────────────────────
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ── 401 par auto logout ───────────────────────────────────────────────────
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401) {
      // Don't intercept 401 on login endpoint itself
      if (err.config?.url && err.config.url.includes("/api/auth/login")) {
        return Promise.reject(err);
      }
      // Try refresh token
      const refresh = localStorage.getItem("refresh_token");
      if (refresh) {
        try {
          const res = await axios.post(
            `${api.defaults.baseURL}/api/auth/refresh`,
            { refresh_token: refresh }
          );
          localStorage.setItem("access_token",  res.data.access_token);
          localStorage.setItem("refresh_token", res.data.refresh_token);
          err.config.headers.Authorization = `Bearer ${res.data.access_token}`;
          return api.request(err.config);
        } catch {
          localStorage.clear();
          window.location.hash = "#/login";
        }
      } else {
        localStorage.clear();
        window.location.hash = "#/login";
      }
    }
    return Promise.reject(err);
  }
);

// ── Auth APIs ──────────────────────────────────────────────────────────────
export const signup  = (data) => api.post("/api/auth/signup",  data).then(r => r.data);
export const login   = (data) => api.post("/api/auth/login",   data).then(r => r.data);
export const logout  = ()     => api.post("/api/auth/logout"       ).then(r => r.data);
export const getMe   = ()     => api.get ("/api/auth/me"           ).then(r => r.data);
export const getProfile     = ()     => api.get  ("/api/auth/profile"     ).then(r => r.data);
export const updateProfile  = (data) => api.patch("/api/auth/profile", data).then(r => r.data);
export const deleteProfile  = ()     => api.delete("/api/auth/profile"    ).then(r => r.data);

// ── Dashboard ──────────────────────────────────────────────────────────────
export const fetchStats = (userId = "", licenseId = "") =>
  api.get("/api/dashboard/stats", {
    params: {
      user_id: userId || undefined,
      license_id: licenseId || undefined
    }
  }).then(r => r.data);

// ── Signals ────────────────────────────────────────────────────────────────
export const fetchSignals = (skip = 0, limit = 50, filters = "") => {
  const params = typeof filters === "string"
    ? { skip, limit, status: filters || undefined }
    : {
        skip,
        limit,
        status: filters.status || undefined,
        action: filters.action || undefined,
        symbol: filters.symbol || undefined,
        date_from: filters.date_from || undefined,
        date_to: filters.date_to || undefined,
        user_name: filters.user_name || undefined,
        license_id: filters.license_id || undefined,
        magic_number: filters.magic_number || undefined,
      };
  return api.get("/api/signals/list", { params }).then(r => r.data);
};

// ── Trades ─────────────────────────────────────────────────────────────────
export const fetchTrades = (skip = 0, limit = 50, filters = {}) =>
  api.get("/api/trades/list", {
    params: {
      skip,
      limit,
      account_id: filters.account_id || undefined,
      user_name: filters.user_name || undefined,
      license_id: filters.license_id || undefined,
      magic_number: filters.magic_number || undefined,
      symbol: filters.symbol || undefined,
      date_from: filters.date_from || undefined,
      date_to: filters.date_to || undefined,
    }
  }).then(r => r.data);

export const fetchSignalCopies = (signalId) =>
  api.get(`/api/trades/signal/${signalId}/copies`).then(r => r.data);

// ── MT5 Accounts ───────────────────────────────────────────────────────────
export const fetchAccounts  = ()           => api.get("/api/accounts/list").then(r => r.data);
export const createAccount  = (data)       => api.post("/api/accounts/create", data).then(r => r.data);
export const updateAccount  = (id, data)   => api.patch(`/api/accounts/update/${id}`, data).then(r => r.data);
export const removeAccount  = (id)         => api.delete(`/api/accounts/delete/${id}`).then(r => r.data);
export const deleteAccount  = removeAccount;

// ── Admin users ──────────────────────────────────────────────────────────
export const fetchAdminUsers = (skip = 0, limit = 50, filters = {}) =>
  api.get("/api/admin/users", {
    params: {
      skip,
      limit,
      status: filters.status || undefined,
      role: filters.role || undefined,
      search: filters.search || undefined,
      service_end_from: filters.service_end_from || undefined,
      service_end_to: filters.service_end_to || undefined,
      created_from: filters.created_from || undefined,
      created_to: filters.created_to || undefined,
    }
  }).then(r => r.data);

export const createAdminUser = (data) =>
  api.post("/api/admin/users", data).then(r => r.data);

export const updateAdminUser = (id, data) =>
  api.patch(`/api/admin/users/${id}`, data).then(r => r.data);

// ── Downloads ──────────────────────────────────────────────────────────────
export const fetchDownloadAssets = () =>
  api.get("/api/downloads/assets").then(r => r.data);

export const downloadAsset = async (assetKey, filename) => {
  const response = await api.get(`/api/downloads/assets/${assetKey}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// ── Webhook test ───────────────────────────────────────────────────────────
export const sendTestSignal = (payload) =>
  api.post("/webhook", payload).then(r => r.data);

// ── Generate License ID ──────────────────────────────────────────────────
export const generateNewLicense = (payload) =>
  api.post("/api/auth/license/create", payload).then(r => r.data);

// ── Email OTP Signup & Forgot Password APIs ─────────────────────────────────
export const requestSignupOTP = (data) =>
  api.post("/api/auth/signup/request-otp", data).then(r => r.data);

export const verifySignupOTP = (data) =>
  api.post("/api/auth/signup/verify", data).then(r => r.data);

export const requestPasswordReset = (data) =>
  api.post("/api/auth/forgot-password/request", data).then(r => r.data);

export const resetPassword = (data) =>
  api.post("/api/auth/forgot-password/reset", data).then(r => r.data);

// ── Plan Renewal Request APIs ───────────────────────────────────────────────
export const sendRenewalRequest = (data) =>
  api.post("/api/auth/renew-request", data).then(r => r.data);

export const createSupportTicket = (payload) =>
  api.post("/api/auth/support/ticket", payload).then(r => r.data);

export const fetchRenewalRequests = () =>
  api.get("/api/admin/renew-requests").then(r => r.data);

export const approveRenewalRequest = (id) =>
  api.post(`/api/admin/renew-requests/${id}/approve`).then(r => r.data);

export const rejectRenewalRequest = (id) =>
  api.post(`/api/admin/renew-requests/${id}/reject`).then(r => r.data);

// ── Notifications APIs ───────────────────────────────────────────────────────
export const fetchNotifications = () =>
  api.get("/api/notifications").then(r => r.data);

export const markNotificationAsRead = (id) =>
  api.post(`/api/notifications/${id}/read`).then(r => r.data);

export const markAllNotificationsAsRead = () =>
  api.post("/api/notifications/read-all").then(r => r.data);

export const broadcastNotification = (data) =>
  api.post("/api/admin/notifications/broadcast", data).then(r => r.data);

export const replyToSupportTicket = (id, data) =>
  api.post(`/api/admin/renew-requests/${id}/reply`, data).then(r => r.data);

// ── Panel Logs APIs ─────────────────────────────────────────────────────────
export const fetchPanelLogs = (skip = 0, limit = 50, filters = {}) =>
  api.get("/api/panel-logs/list", {
    params: {
      skip,
      limit,
      user_id: filters.user_id || undefined,
      action: filters.action || undefined,
      date_from: filters.date_from || undefined,
      date_to: filters.date_to || undefined,
    }
  }).then(r => r.data);

export const fetchPanelActions = () =>
  api.get("/api/panel-logs/actions").then(r => r.data);

// ── Plans APIs ─────────────────────────────────────────────────────────────
export const fetchPlans = () =>
  api.get("/api/plans/list").then(r => r.data);

export const createPlan = (payload) =>
  api.post("/api/plans/admin/create", payload).then(r => r.data);

export const deletePlan = (planId) =>
  api.delete(`/api/plans/admin/delete/${planId}`).then(r => r.data);

export const purchasePlan = (payload) =>
  api.post("/api/plans/purchase", payload).then(r => r.data);

export const fetchPayments = () =>
  api.get("/api/plans/admin/payments").then(r => r.data);

export const fetchPlanLogs = () =>
  api.get("/api/plans/admin/logs").then(r => r.data);

// User's own transaction history
export const fetchMyTransactions = () =>
  api.get("/api/plans/my-transactions").then(r => r.data);

// Razorpay payment gateway
export const razorpayCreateOrder = (payload) =>
  api.post("/api/plans/razorpay/create-order", payload).then(r => r.data);

export const razorpayVerifyPayment = (payload) =>
  api.post("/api/plans/razorpay/verify", payload).then(r => r.data);

// ── Project Docs (PineBot Knowledge Base) ──────────────────────────────────
export const searchProjectDocs = (query, category = "", limit = 5) =>
  api.get("/api/docs/search", { params: { q: query || undefined, category: category || undefined, limit } }).then(r => r.data);

export const fetchDocById = (docId) =>
  api.get("/api/docs/search", { params: { doc_id: docId } }).then(r => r.data);

export const listDocCategories = () =>
  api.get("/api/docs/list").then(r => r.data);

export default api;

